import { Button } from 'antd';
import * as React from 'react';
import { IOrderInfo } from 'src/entity/OrderEntity';
import I18N from 'src/services/I18NService';
import { MallEdiService, IOrderMedicineStatus } from 'src/services/MallEdiService';
import { MddCommon } from '@macrocura/utils';
import { CATEGORY_ORIGINAL } from 'src/constants/Order';

interface ISendMedicinesProps {
  /** 订单明细 */
  orderInfo: IOrderInfo;
  /**  */
  sendMedicineConfig: boolean;
  callback?(orderInfo: IOrderMedicineStatus[]): Promise<void>;
}

interface ISendMedicineState {
  sending: boolean;
  statusList: IOrderMedicineStatus[];
  loading: boolean;
}

class SendMedicines extends React.Component<ISendMedicinesProps, ISendMedicineState> {
  timeOutId: number | undefined;
  sendMedicineConfig = false;
  constructor(props: ISendMedicinesProps) {
    super(props);

    this.state = {
      sending: false,
      statusList: [],
      loading: false,
    };
  }

  // async componentDidMount() {
  // const config = await MallEdiService.getSendOrderMedicineConfig();
  // if (!!config) {
  //   // let statusList: IOrderMedicineStatus[] = [];
  //   this.setState({
  //     isSendOrder: config.is_enabled,
  //   });
  //   if (config.is_enabled) {
  //     await this.autoFetchSendStatus(1000);
  //     // statusList = await MallEdiService.getSendOrderMedicineResult(this.props.orderInfo.id);
  //   }

  //   // this.setState(
  //   //   {
  //   //     isSendOrder: config.is_enabled,
  //   //     statusList,
  //   //   },
  //   //   async () => {
  //   //     if (config.is_enabled) {
  //   //       const currentStatus = this.hasSending();
  //   //       if (currentStatus) {
  //   //         await this.autoFetchSendStatus(1000);
  //   //       }
  //   //     }
  //   //   }
  //   // );
  // }
  // }

  async componentDidUpdate() {
    const { sendMedicineConfig } = this.props;
    if (this.sendMedicineConfig !== sendMedicineConfig && !!sendMedicineConfig) {
      this.sendMedicineConfig = sendMedicineConfig;
      if (sendMedicineConfig) {
        await this.autoFetchSendStatus(1000);
      }
    }
  }

  componentWillUnmount() {
    if (!!this.timeOutId) {
      clearTimeout(this.timeOutId);
    }
    this.setState = () => {
      return;
    };
  }

  /**
   * 发送事件
   *
   * @memberof SendMedicines
   */
  onSend = async () => {
    if (this.state.sending) {
      return;
    }
    const { orderInfo } = this.props;
    if (!!orderInfo && !!orderInfo.id) {
      this.setState({
        sending: true,
      });
      this.timeOutId = window.setTimeout(() => {
        this.setState({
          sending: false,
        });
      }, 500);
      const res = await MallEdiService.sendOrderMedicine(orderInfo.id);
      // 如果发送药品清单没有失败的处方订单则触发回调，刷新订单数据
      await this.autoFetchSendStatus(1000);
    }
  };

  /**
   * 获取发送结果的显示状态
   *
   * @memberof SendMedicines
   */
  getStatus = (): JSX.Element[] => {
    const result: JSX.Element[] = [];
    const { orderInfo } = this.props;
    const { statusList } = this.state;

    for (const obj of statusList) {
      result.push(
        <span key={obj.group.toString()} style={{ marginLeft: '16px' }}>
          {orderInfo.category !== CATEGORY_ORIGINAL ? I18N.get('common_unit_prescription') + (obj.group + 1) : ''}
          {I18N.get('common_status')}：
          {obj.status === 'SUCCESS' ? (
            <span style={{ color: '#1fb8cd' }}>{I18N.get('order_send_medicine_success')}</span>
          ) : obj.status === 'FAILED' ? (
            <span style={{ color: '#f31212' }}>
              {I18N.get('order_send_medicine_failed')}, {obj.error_message}
            </span>
          ) : (
                <span>{I18N.get('order_send_medicine_sending')}</span>
              )}
        </span>
      );
    }

    return result;
  };

  /**
   * 自动请求发送结果
   *
   * @memberof SendMedicines
   */
  autoFetchSendStatus = async (ms: number) => {
    if (this.state.loading) {
      return;
    }

    this.setState({
      loading: true,
    });
    try {
      await MddCommon.sleep(ms);

      const statusList = await MallEdiService.getSendOrderMedicineResult(this.props.orderInfo.id);
      if (!!this.props.callback) {
        await this.props.callback(statusList);
      }
      this.setState(
        {
          statusList,
          loading: false,
        },
        async () => {
          const currentStatus = this.hasSending();
          if (!!currentStatus) {
            if (ms < 1000 * 60) {
              ms += 1000;
            }
            await this.autoFetchSendStatus(ms);
          }
        }
      );
    } catch (error) {
      console.error(error);
      this.setState({
        loading: false,
      });
    }
  };

  /**
   * 是否存在Sending状态的订单
   *
   * @memberof SendMedicines
   */
  hasSending = (): boolean => {
    const { statusList } = this.state;

    let result = false;
    for (const obj of statusList || []) {
      result = result || obj.status === 'PREPARE' || obj.status === 'SENDING';
    }

    return result;
  };

  /**
   * 是否全部成功
   *
   * @memberof SendMedicines
   */
  isAllSuccess = (): boolean => {
    const { statusList } = this.state;

    let result = statusList.length > 0;

    for (const obj of statusList) {
      result = result && obj.status === 'SUCCESS';
    }
    return result;
  };

  render() {
    const { sendMedicineConfig } = this.props;
    // 去除区分处方、药品订单 2021-5-24
    return sendMedicineConfig ? (
      <div className="div-row">
        <div className="div-col-3 text-align-right">{I18N.get('order_docking_system')}</div>
        <div className="div-col-15 order_info" style={{ paddingBottom: '16px' }}>
          <Button disabled={this.isAllSuccess()} type="primary" onClick={this.onSend} >
            {I18N.get('order_send_medicine')}
          </Button>
          {this.getStatus()}
        </div>
      </div>
    ) : null;
  }
}

export default SendMedicines;



// WEBPACK FOOTER //
// ./src/components/views/Order/components/SendMedicines.tsx